import * as Yup from "yup";

const ChildStep9chema = Yup.object().shape({
  signature: Yup.string().nullable().required("Signature is required"),
  authorize: Yup.bool().nullable().oneOf([true], "You must authorise conset to medical treatment"),
  informationIsTrue: Yup.bool().nullable().oneOf([true], "You must agree that all information is true"),
});

export default ChildStep9chema;
